<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("role", 2) }} List</div>
        <div class="section-subTitle my-2">{{ $t("role_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Roles')"
          variant="default"
          @click="
            $router.push({
              path: '/user-management/role-form',
              query: {
                id: 'new',
              },
            })
          "
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <div>
          <b-form-input
            v-debounce:300="getRolesList"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingNumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <!-- <img
              v-if="!isSort"
              @click="onSortValue('role_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('role_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('role_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            /> -->
            {{ $tc("role", 1) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="Roles.length > 0">
        <tr v-for="(item, key) in Roles" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.role_is_active ? 'active' : 'inactive'"
              />
              <div
                v-if="$can('update', 'Roles')"
                @click="
                  $router.push({
                    path: '/user-management/role-form',
                    query: {
                      id: item.role_id,
                    },
                  })
                "
                class="btn-icon ml-4"
                style="cursor: pointer; position: relative"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon" style="cursor: pointer"></i>
              </div>
              <div
                @click="
                  $router.push({
                    path: '/user-management/role-details',
                    query: {
                      id: item.role_id,
                    },
                  })
                "
                class="btn-icon ml-2"
                style="cursor: pointer; position: relative"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon" style="cursor: pointer"></i>
              </div>
            </div>
          </td>

          <td>{{ $tc(item.role_name, 1) }}</td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import UserManagmentServices from "@/services/UserManagmentServices.js";
import StatusDot from "@/components/Partials/StatusDot.vue";

export default {
  components: {
    StatusDot,
  },
  data() {
    return {
      searchValue: "",

      perPage: 10,

      currentPage: 1,

      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,

      Roles: [],

      viewingNumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
      customErrors: {
        message: "",
      },

      isSort: false,
      isAscending: true,
      orderBy: "",
      columnName: "",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    onChangePagination(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getRolesList();
      } else {
        this.currentPage = event;
        this.getRolesList();
      }
    },

    async getRolesList() {
      try {
        this.Roles = [];
        const response = await UserManagmentServices.getAllRoles({
          perPage: this.perPage,
          currentPage: this.currentPage,
          searchValue: this.searchValue,
        });
        console.log(this.secureStore.get("USINFO").role_id, "role_id");
        if (this.secureStore.get("USINFO").role_id == 1) {
          this.Roles = [
            {
              role_id: 1,
              role_name: "Super Admin",
              role_is_cinema_level: "N",
              role_is_active: "N",
              created_at: "2019-07-26T12:20:00.000Z",
              created_by: 1,
              updated_at: "2023-03-23T05:33:42.000Z",
              updated_by: 1,
            },
            ...response.data.data.data,
          ];
        } else {
          this.Roles = response.data.data.data;
        }
        if (response.data.data.pagination.total)
          this.rows = response.data.data.pagination.total;
      } catch (error) {
        console.log("Error in getRolesList ", error);
      }
    },
  },
  beforeMount() {
    this.getRolesList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/Roles/RolesList.vue